import { createSlice } from '@reduxjs/toolkit';
import { getLocations } from 'ducks/locations-list/operators';
import { Slices } from 'ducks/slices';
import { normalizeLookups } from 'ducks/utils';

export type LocationsListState = ReturnType<typeof normalizeLookups<'location_name', 'location_id'>>;

const initialState: LocationsListState = [];

export const locationsListSlice = createSlice({
  name: Slices.LOCATION_LIST,
  initialState,
  reducers: {
    clearLocationsList: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLocations.pending, () => {
        return initialState;
      })
      .addCase(getLocations.fulfilled, (_, { payload }) => {
        return normalizeLookups(payload, 'location_name', 'location_id');
      })
      .addCase(getLocations.rejected, () => {
        return initialState;
      });
  },
});

export const { clearLocationsList } = locationsListSlice.actions;

export default locationsListSlice.reducer;
